/*
 * types/services/dr2am.tasks.orders.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {ProtobufAny} from './ProtobufAny';

/**
 * The RuntimeError model module.
 * @module model/RuntimeError
 * @version version not set
 */
export class RuntimeError {
  /**
   * Constructs a new <code>RuntimeError</code>.
   * @alias module:model/RuntimeError
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>RuntimeError</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RuntimeError} obj Optional instance to populate.
   * @return {module:model/RuntimeError} The populated <code>RuntimeError</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new RuntimeError();
      if (data.hasOwnProperty('error'))
        obj.error = ApiClient.convertToType(data['error'], 'String');
      if (data.hasOwnProperty('code'))
        obj.code = ApiClient.convertToType(data['code'], 'Number');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
      if (data.hasOwnProperty('details'))
        obj.details = ApiClient.convertToType(data['details'], [ProtobufAny]);
    }
    return obj;
  }
}

/**
 * @member {String} error
 */
RuntimeError.prototype.error = undefined;

/**
 * @member {Number} code
 */
RuntimeError.prototype.code = undefined;

/**
 * @member {String} message
 */
RuntimeError.prototype.message = undefined;

/**
 * @member {Array.<module:model/ProtobufAny>} details
 */
RuntimeError.prototype.details = undefined;


